import React, { useEffect, useRef } from 'react'
import Radio from '@material-ui/core/Radio';

const SarasRadioBox2 = (props)=>{
    const {id,value,name,className,onChange} = props
    const [isChecked, setIsChecked] = React.useState(false);
    const radioBoxRef = useRef();

    const initializeValue = () => {
      if (value && (value === 'Yes' || value === "1"))
          setIsChecked(true)
      else
          setIsChecked(false)
    }

    useEffect(initializeValue, [value])

    const onSelectionChange = () => {
      const isChecked = radioBoxRef.current.checked;
        setIsChecked(isChecked)
        if (onChange) onChange(radioBoxRef, isChecked ? '1' : '0')
    }

    return(
        <Radio ref={radioBoxRef}
          id={id}
          classes={className}
          checked={isChecked}
          onChange={onSelectionChange}
          value={value}
          color="default"
          name={name}
          inputProps={{ 'aria-label': 'E' }}
          size="small"
        />
    )
}

export default SarasRadioBox2